var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-swiper"},[_c('Swiper',{staticClass:"swiper"},_vm._l((_vm.topImages),function(item){return _c('slide',[_c('img',{attrs:{"src":item}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }